import { useEffect, useState } from 'react';
import type { DecoratedMagicJob } from '@/features/magic/types';

export const useJob = (job?: DecoratedMagicJob | null) => {
  const [statefulJob, setStatefulJob] = useState<DecoratedMagicJob | null>(
    job ?? null
  );

  // Bootstrapped jobs are provided via props
  useEffect(() => {
    setStatefulJob(job ?? null);
  }, [job]);

  return {
    job: statefulJob,
    setJob: setStatefulJob,
  };
};
